import ArrowGoBack from "../../components/ArrowGoBack/ArrowGoBack";
import reportsIcon from "../../assets/icons/navbar/Reports@4x.png";
import styles from "./index.module.css";
import { connect } from "react-redux";
import { getModules } from "../../actions/productsActions";
import { useEffect, useState } from "react";
import {
  clearReports,
  getFullCompletionUsers,
  getGeneralReport,
  getReportsByGroupProduct,
  getReportsByProduct,
  getTotalModules,
  getTotalStudents,
  getTotalTimeSpent,
  getTotalRate,
  updateReportsInfo,
} from "../../actions/reportsActions";
import ReportsTable from "./reports_table/reports_table";
import { Outlet } from "react-router-dom";
import IndexLearner from "./learnerView";
import {
  closeLoading,
  openLoading,
} from "../../components/loadingModal/loading";
import alert from "../../components/AlertModal/alertModal";
import { getCourses } from "../../actions/manageCoursesActions";
import MaterialSelect from "../../components/MaterialSelect";
import { Skeleton } from "@mui/material";
import CircleBadge from "../../components/CircleBadge";

const AdminView = (props) => {
  const {
    getCourses,
    getReportsByGroupProduct,
    getModules,
    userPermissions,
    getReportsByProduct,
    // getTotalModules,
    getTotalStudents,
    getTotalTimeSpent,
    getFullCompletionUsers,
    getTotalRate,
    reports,
    reportsInfo,
    modules,
    clearReports,
    courses,
    updateReportsInfo,
  } = props;

  const [text, setText] = useState("Select a Module");

  // Función para cargar totales generales
  const loadGeneralTotals = async () => {
    if (userPermissions.includes(17)) {
      await Promise.all([
        // getTotalModules(),
        getTotalStudents(),
        getTotalTimeSpent(),
        getFullCompletionUsers(),
        getTotalRate(),
      ]);
    }
  };

  // Función para cargar reportes por curso
  const loadCourseReports = async (courseId, moduleId) => {
    await clearReports();

    if (courseId === "0") {
      await getReportsByProduct({ idProduct: moduleId });
      setText("There are no reports for this module");
    } else {
      await getReportsByGroupProduct({
        idCourse: courseId,
        idProduct: moduleId,
      });
      setText("There are no reports for this course");
    }
  };

  const getInitialData = async () => {
    openLoading();
    try {
      await getModules({
        userProducts: true,
        include: { idModule: "0", name: "All" },
      });
      await updateReportsInfo({ moduleId: "0", courseId: "0" });
      setText("Select a Module");
      closeLoading();
      await loadGeneralTotals();
    } catch (error) {
      alert("ERROR", error);
    } finally {
      closeLoading();
    }
  };

  useEffect(() => {
    if (reportsInfo.totalUsers === undefined) {
      getInitialData();
    }
  }, []);

  const totalTime = () => {
    const minutes = reportsInfo.totalTimeSpent / 60;
    return reportsInfo.totalTimeSpent > 0 ? `${minutes.toFixed()}` : undefined;
  };

  const handleSelectProduct = async (e) => {
    const {
      target: { value },
    } = e;

    await updateReportsInfo({ moduleId: value });

    openLoading();
    try {
      if (value === "0") {
        // Si selecciona "All" en módulos
        await updateReportsInfo({ courseId: "0" });
        setText("Select a Module");
        await clearReports();
        await loadGeneralTotals();
      } else {
        // Si selecciona un módulo específico
        await getCourses({
          moduleIdModule: value,
          active: true,
          include: { idCourse: "0", name: "All" },
        });

        // Actualizar a curso "All" (id: "0")
        await updateReportsInfo({ courseId: "0" });

        // AQUÍ SE LLAMA AUTOMÁTICAMENTE LA FUNCIÓN PARA CARGAR REPORTES DEL CURSO "ALL"
        await loadCourseReports("0", value);
      }
    } catch (error) {
      alert("ERROR", error);
    } finally {
      closeLoading();
    }
  };

  const handleSelectCourse = async (e) => {
    const {
      target: { value },
    } = e;

    console.log("Selected course ID:", value);

    await updateReportsInfo({ courseId: value });

    openLoading();
    try {
      await loadCourseReports(value, reportsInfo.moduleId);
    } catch (error) {
      alert("ERROR", error);
    } finally {
      closeLoading();
    }
  };

  // Renderizado condicional basado en permisos
  if (!userPermissions.includes(15)) {
    return <IndexLearner />;
  }

  const courseOptions =
    courses && courses.length > 0
      ? courses.map((course) => ({
          id: course.idCourse,
          label: course.name,
        }))
      : [{ id: "0", label: "All" }];

  const moduleOptions =
    modules?.map((module) => ({
      id: module.idModule,
      label: module.name,
    })) || [];

  return (
    <div className={`box-container ${styles.container}`}>
      <ArrowGoBack max={2} />
      <div className={styles.headerContainer}>
        <img src={reportsIcon} alt="Reports Icon" className="icon_head" />
        <div className={styles.select}>
          <MaterialSelect
            label="Module"
            formField="Module"
            value={reportsInfo.moduleId}
            onChange={handleSelectProduct}
            options={moduleOptions}
          />
        </div>
        <div className={styles.select}>
          <MaterialSelect
            label="Course"
            formField="course"
            disabled={
              reportsInfo.moduleId === "0" || courseOptions.length === 0
            }
            value={reportsInfo.courseId}
            onChange={handleSelectCourse}
            options={courseOptions}
          />
        </div>
      </div>
      <div className={styles.circlesContainer}>
        <StatBadge value={reportsInfo.totalUsers} label="TOTAL STUDENTS" />
        <StatBadge value={totalTime()} label="TOTAL TIME SPENT (MINS)" />
        <StatBadge
          value={reportsInfo.studentsFullCompletion}
          label="STUDENTS FULL COMPLETION"
        />
        <StatBadge
          value={
            reportsInfo.totalRate !== undefined
              ? `${Number(reportsInfo.totalRate).toFixed()} %`
              : undefined
          }
          label="COMPLETION RATE"
        />
      </div>
      {reports && reports.length > 0 ? (
        <div className={styles.tableContainer}>
          <ReportsTable reports={reports} />
        </div>
      ) : (
        <div className="text-title-slow">{text}</div>
      )}
      <Outlet />
    </div>
  );
};

// Componente auxiliar para los badges de estadísticas
const StatBadge = ({ value, label }) => (
  <div className={styles.circleCon}>
    <CircleBadge
      type="main"
      value={
        value !== undefined ? (
          <span>{value}</span>
        ) : (
          <Skeleton
            width={50}
            height={20}
            animation="wave"
            sx={{
              bgcolor: "rgba(200, 200, 200, 0.3)",
              "&::after": {
                background:
                  "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)",
              },
              borderRadius: "4px",
            }}
          />
        )
      }
    />
    <div className={styles.textCircle}>{label}</div>
  </div>
);

const mapStateToProps = (state) => {
  return {
    userPermissions: state.usersReducer.userLogged.permissions,
    products: state.productsReducer.allProducts,
    groups: state.metricIndividualReducer.groupsByProduct,
    reports: state.metricIndividualReducer.reports,
    reportsInfo: state.metricIndividualReducer.reportsInfo,
    modules: state.productsReducer.allProducts,
    courses: state.manageCourses.coursesList,
  };
};

export default connect(mapStateToProps, {
  getCourses,
  getReportsByGroupProduct,
  getModules,
  getGeneralReport,
  getReportsByProduct,
  getTotalModules,
  getTotalStudents,
  getTotalTimeSpent,
  getFullCompletionUsers,
  getTotalRate,
  clearReports,
  updateReportsInfo,
})(AdminView);
